import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SchoolInfo } from "./shared/SchoolInfo";
import { DataService_LocationMaintenance } from "./shared/data.service";
import { wsFacilityLocationListInfo } from "./shared/wsFacilityLocationListInfo";
import { MsLocationAddComponent } from "./ms-location-add/ms-location-add.component";
import { MsLocationEditComponent } from "./ms-location-edit/ms-location-edit.component";
import { Dropdown } from "primeng/dropdown";

@Component({
	selector: "app-multi-station-location-maintenance",
	templateUrl: "./multi-station-location-maintenance.component.html",
	styleUrls: ["./multi-station-location-maintenance.component.css"],
})
export class MultiStationLocationMaintenanceComponent implements OnInit {
	@ViewChild("mydt") mydt: Table;
	@ViewChild("filterActive", { static: false }) public filterActive: Dropdown;
	@ViewChild("filterFacilityName", { static: false })
	public filterFacilityName: Dropdown;
	@ViewChild("filterFacilityLocationCD", { static: false })
	public filterFacilityLocationCD: Dropdown;

	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_LocationMaintenance,
		private userService: UserService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public ErrorMessage: string = "";

	//	School Selector
	public PreSelectSchoolID: any = -1; // -1 = [no selection]
	public lstSchool: any = [];
	public SelectedSchool: SchoolInfo;

	//	Facility Location List
	public lstFacilityLocation: wsFacilityLocationListInfo[] = [];
	public SelectedFacilityLocation: wsFacilityLocationListInfo;

	//	Filters
	public lstActives: any = [];
	public lstFacilitys: any = [];
	public lstFacilityLocationCDs: any = [];

	//	Facility Location Counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	subscription: any;
	SchoolSelectShowAll: any = true;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "- Select a School -";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		// this.LoadSchoolList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClearFilters
	//
	//-----------------------------------------------------------------------------------------------------
	onClearFilters() {
		this.filterActive.clear(null);
		this.filterFacilityName.clear(null);
		this.filterFacilityLocationCD.clear(null);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		this.isBusy = true;
		this.ErrorMessage = "";
		this.dataService.FacilityLocationSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.FacilityLocationSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	FacilityLocationSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	FacilityLocationSelectList_Complete(data: any) {
		this.SelectedFacilityLocation = null;
		this.lstFacilityLocation = data;

		//
		//	Set Filter Lists
		//
		this.lstActives = Array.from(new Set(this.lstFacilityLocation.map((item: any) => item.ActiveDesc)));
		this.lstFacilitys = Array.from(new Set(this.lstFacilityLocation.map((item: any) => item.FacilityName)));
		this.lstFacilityLocationCDs = Array.from(new Set(this.lstFacilityLocation.map((item: any) => item.FacilityLocationCD)));

		//
		//	Reset Filters
		//
		this.onClearFilters();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({
			field: "FacilityLocationName",
			order: 1,
		});
		this.mydt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAdd
	//
	//-----------------------------------------------------------------------------------------------------
	onAdd() {
		//
		//	Validate
		//
		if (this.SelectedSchool == null || this.SelectedSchool.SchoolID < 1) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a school.",
				header: "Add Facility Location",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
			return;
		}

		//
		//	Display Add Popup
		//
		var ref = this.dialogService.open(MsLocationAddComponent, {
			header: "Add Facility Location",
			width: "435px",
			data: {
				UserPersonID: this.user.personID,
				SchoolID: this.SelectedSchool.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEdit
	//
	//-----------------------------------------------------------------------------------------------------
	onEdit() {
		//
		//	Validate
		//
		if (this.SelectedFacilityLocation == null || this.SelectedFacilityLocation.FacilityLocationID < 1) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a facility location.",
				header: "Edit Facility Location",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
			return;
		}

		//
		//	Display Edit Popup
		//
		var ref = this.dialogService.open(MsLocationEditComponent, {
			header: "Edit Facility Location",
			width: "435px",
			data: {
				UserPersonID: this.user.personID,
				SchoolID: this.SelectedSchool.SchoolID,
				SelectedFacilityLocation: this.SelectedFacilityLocation,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleActive
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleActive() {
		if (this.SelectedFacilityLocation == null) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a facility location.",
				header: "Active/Inactive",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		} else {
			this.isBusy = true;
			this.dataService
				.FacilityLocationToggleActive(this.SelectedFacilityLocation.FacilityLocationID)
				.subscribe((data) => this.FacilityLocationToggleActive_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	FacilityLocationToggleActive_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	FacilityLocationToggleActive_Complete(data: any) {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) {
		//
		//	Need to set SelectedFacilityLocation here. We don't unselect when selected.
		//
		this.SelectedFacilityLocation = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadSchoolList
	//
	//-----------------------------------------------------------------------------------------------------
	LoadSchoolList() {
		var result = this.schoolService.loadSchoolList("");

		result.subscribe(
			(response) => {
				this.lstSchool = response;
				let isItemFound: boolean = false;
				let isSchoolSelected: boolean = false;

				//
				//	Add the [- Select a school -] to the top of the list
				//
				//	Note: "- Select a school" is put in SchoolNumber to match the HTML formatting.
				//		this allows it to show with a visual appeal that matches the rest of the items.
				//
				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolNumber: "- Select a school",
					SchoolName: "",
				});

				//
				//	if PreSelectSchoolID has a value not equal -1 then try to select the item
				//
				this.lstSchool.forEach((item) => {
					if (this.PreSelectSchoolID == item.SchoolID && isItemFound == false && this.PreSelectSchoolID != -1) {
						this.SelectedSchool = item;
						isItemFound = true;
						isSchoolSelected = true;
					}
				});

				//
				//	if PreSelectSchoolID was not found
				//
				if (isItemFound == false) {
					//
					//	If there is only 1 school in list and (PreSelectSchoolID = -1 or PreSelectSchoolID matched the school)
					//	then select it. otherwise select the [- Select a School -] item.
					//
					if (this.lstSchool.length == 2) {
						if (this.PreSelectSchoolID == -1 || this.PreSelectSchoolID == this.lstSchool[1].SchoolID) {
							this.SelectedSchool = this.lstSchool[1];
							isSchoolSelected = true;
						} else {
							this.SelectedSchool = this.lstSchool[0];
						}
					} else {
						this.SelectedSchool = this.lstSchool[0];
					}
				}

				this.isBusy = false;

				if (isSchoolSelected == true) {
					this.onRefresh();
				}
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolChange(value) {
		this.SelectedSchool = value;

		if (this.SelectedSchool.SchoolID > 0) {
			this.onRefresh();
		} else {
			this.lstFacilityLocation = [];
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
